import React from 'react';

const styles = {
  footer: {
    position: 'relative',
    zIndex: 1,
    borderTop: '1px solid rgba(255, 255, 255, 0.05)',
    padding: '60px 24px 40px',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: 'center',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
  },
  logoIcon: {
    fontSize: '28px',
    color: '#3b82f6',
  },
  logoText: {
    fontSize: '22px',
    fontWeight: '700',
    fontFamily: "'Space Grotesk', sans-serif",
    color: '#fff',
  },
  logoAccent: {
    color: '#3b82f6',
  },
  tagline: {
    fontSize: '16px',
    color: '#64748b',
    marginTop: '12px',
    marginBottom: '32px',
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    gap: '32px',
    marginBottom: '40px',
    flexWrap: 'wrap',
  },
  link: {
    color: '#94a3b8',
    textDecoration: 'none',
    fontSize: '15px',
    transition: 'color 0.2s ease',
  },
  bottom: {
    borderTop: '1px solid rgba(255, 255, 255, 0.05)',
    paddingTop: '24px',
  },
  copyright: {
    fontSize: '14px',
    color: '#64748b',
  },
  credit: {
    fontSize: '13px',
    color: '#475569',
    marginTop: '12px',
  },
  creditLink: {
    color: '#3b82f6',
    textDecoration: 'none',
    fontWeight: '500',
    transition: 'color 0.2s ease',
  },
};

export const Footer = () => {
  const navLinks = [
    { href: '#diensten', label: 'Diensten' },
    { href: '#pakketten', label: 'Pakketten' },
    { href: '#proces', label: 'Werkwijze' },
    { href: '#faq', label: 'FAQ' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <footer style={styles.footer}>
      <div style={styles.content}>
        <div style={styles.logo}>
          <span style={styles.logoIcon}>◈</span>
          <span style={styles.logoText}>
            ClearData<span style={styles.logoAccent}>Ops</span>
          </span>
        </div>
        <p style={styles.tagline}>
          Betrouwbare CRM data. Structureel.
        </p>
        <div style={styles.links}>
          {navLinks.map((link, i) => (
            <a key={i} href={link.href} style={styles.link}>
              {link.label}
            </a>
          ))}
        </div>
        <div style={styles.bottom}>
          <p style={styles.copyright}>
            © 2025 ClearData Ops. Alle rechten voorbehouden.
          </p>
          <p style={styles.credit}>
            Design & Development — <a href="https://ensalabs.nl" target="_blank" rel="noopener noreferrer" style={styles.creditLink} className="nav-link">ensalabs</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
